<template>
  <div class="relative">
    <BusinessBody />
  </div>
</template>
<script>
import BusinessBody from "./components/BusinessBody";
export default {
  components: {
    BusinessBody,
  },
  methods: {},
};
</script>
